import React from 'react';

const Version = ({ fixed = true }) => {
    const version = import.meta.env.VITE_APP_VERSION || '0.0.0';

    return (
        <div style={{ position: fixed ? 'fixed' : 'static', bottom: 10, left: 10 }}>
            Ver.: {version}
        </div>
    );
};

export default Version;